import StatusInfoModal from './StatusInfoModal';

export default StatusInfoModal;
